<section>
  <div class="row mt-2 mb-2">
    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12">
      <div class="content-header f_20 module-header ml-2 mt-18px">Performance Bonus Overview</div>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 text-center">
      <div class="content-header f_20 module-header mr-2 mt-18px">My Slab - {{slab}}</div>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12">
      <button class="btn btn-primary pull-right color-white mt-2 color-white users-btn mr-2 pull-right"
              (click)="showSearch = !showSearch">
        <i aria-hidden="true" class="fa fa-search mr-2"></i>Search
      </button>
    </div>
  </div>
  <div class="row mt-2 mb-2" *ngIf="showSearch">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <form class="form background-white ml-15px mr-15px" novalidate [formGroup]="searchForm">
        <div class="row">
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <div class="form-group ml-2 pt-3 pb-1 mt--5px">
              <input class="form-control" id="direct_id" type="text" formControlName="direct_id"
                     placeholder="Direct Id">
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <div class="form-group ml-2 pt-3 pb-1 mt--5px">
              <input class="form-control" id="direct_user_slab" type="text" formControlName="direct_user_slab"
                     placeholder="Direct User Slab">
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 text-center">
            <button class="btn btn-primary btn-block btn-raised color-white mt-16px ml--10px" (click)="search()">
              Search
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="row p-sm-2 d-none d-md-block overflow-x-scroll">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <table class="table table-list overflow-x-scroll">
        <thead>
        <tr>
          <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">S.No</h6></th>
          <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Transaction No</h6></th>
          <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Direct Id</h6></th>
          <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Direct Username</h6></th>
          <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Direct User Slab</h6></th>
          <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Total Team Purchase</h6></th>
          <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Commission Slab</h6></th>
          <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Upcoming Commission</h6></th>
          <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Status</h6></th>
        </tr>
        </thead>
        <tbody *ngIf="performanceBonusOverview && performanceBonusOverview.length > 0; else noDataToShowWeb">
        <tr *ngFor="let performanceBonus of performanceBonusOverview; let i = index">
          <td class="text-center">
            <h6 class="mt-1">{{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1}}.</h6>
          </td>
          <td class="text-center"><h6 class="mt-1">{{performanceBonus?.transaction_no}}</h6></td>
          <td class="text-center"><h6 class="mt-1">{{performanceBonus?.direct_id}}</h6></td>
          <td class="text-center"><h6 class="mt-1">{{performanceBonus?.direct_user_name}}</h6></td>
          <td class="text-center"><h6 class="mt-1">{{performanceBonus?.direct_user_slab}}</h6></td>
          <td class="text-center"><h6 class="mt-1">{{performanceBonus?.total_team_purchase}}</h6></td>
          <td class="text-center"><h6 class="mt-1">{{performanceBonus?.commission_slab}}</h6></td>
          <td class="text-center"><h6 class="mt-1">{{performanceBonus?.upcoming_commission}}</h6></td>
          <td class="text-center"><h6 class="mt-1">{{performanceBonus?.status}}</h6></td>
        </tr>
        </tbody>
        <ng-template #noDataToShowWeb>
          <tbody>
          <tr>
            <td colspan="9" class="text-center"><h6>No data to show</h6></td>
          </tr>
          </tbody>
        </ng-template>
      </table>
    </div>
  </div>

  <div class="row d-block d-md-none" *ngIf="performanceBonusOverview && performanceBonusOverview.length > 0; else noDataToShowMobile">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="card" *ngFor="let performanceBonus of performanceBonusOverview; let i = index">
        <div class="card-header bottom-shadow-light pb-18px">
          <div class="row">
            <div class="col-12">
              <h4 class="card-title text-uppercase card-ellipsis pb-3">{{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1}}. {{performanceBonus?.transaction_no}}</h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row p-2">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
              Direct Id - {{performanceBonus?.direct_id}}
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
              Direct Username - {{performanceBonus?.direct_user_name}}
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
              Direct User Slab - {{performanceBonus?.direct_user_slab}}
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
              Total Team Purchase - {{performanceBonus?.total_team_purchase}}
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
              Commission Slab - {{performanceBonus?.commission_slab}}
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
              Upcoming Commission - {{performanceBonus?.upcoming_commission}}
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
              Status - {{performanceBonus?.status}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #noDataToShowMobile>
    <div class="row d-block d-md-none">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="card text-center">
          <h5 class="p-5">No data to show</h5>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="row pagination-table">
    <ngb-pagination (pageChange)="onPageChange($event)"
                    [(page)]="pagination.page"
                    [boundaryLinks]="true"
                    [collectionSize]="pagination.total"
                    [maxSize]="3"
                    [pageSize]="pagination.perpage">
    </ngb-pagination>
  </div>
</section>
